import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import Button from '../../../../Button';
import styles from './SelectedFeaturesFooter.module.scss';
import { SidebarActions, ActionButton } from '../../../SidebarActions';
import SidebarFooter from '../../../SidebarFooter';
import HuntsIcon from '../../../../../assets/svg/HuntsIcon';
import CornerRightUp from '../../../../../assets/svg/Feather/CornerRightUp';
import Pencil from '../../../../../assets/svg/Feather/Pencil';
import Trash2 from '../../../../../assets/svg/Feather/Trash2';
import actions from './actions';
import ghAnalytics from '../../../../../lib/analytics';

function SelectedFeaturesFooter(props) {
  const cancelAction = () => {
    props.cancelAction(props.selectedFeatures);
  };

  // we're imitating toggleEditFeature here
  const editStyles = () => {
    props.toggleEditStyles();
    ghAnalytics.logBulkEditStart(); // For Analytics
  };

  const showExportModal = () => {
    props.showExportModal(props.selectedFeatures);
  };

  const showAddToCollectionModal = () => {
    props.showAddToCollectionModal(props.selectedFeatures);
  };

  const showDeleteModal = () => {
    props.showDeleteModal(props.selectedFeatures);
  };

  return (
    <SidebarFooter className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.text}>
          <span className={styles.title}>Bulk Actions</span>
          <span className={styles.hint}>Save time and update multiple map items at the same time.</span>
        </div>
        <SidebarActions>
          <>
            <ActionButton icon={Pencil} active={props.isEditingFeature} onClick={editStyles}>
              Styles
            </ActionButton>
            <ActionButton icon={CornerRightUp} onClick={showExportModal}>
              Export
            </ActionButton>
            <ActionButton icon={HuntsIcon} onClick={showAddToCollectionModal}>
              Hunts
            </ActionButton>
            <ActionButton icon={Trash2} onClick={showDeleteModal}>
              Delete
            </ActionButton>
          </>
        </SidebarActions>
      </div>
      <div className={styles.separator} />
      <Button theme={Button.THEME.ghostPrimary} disabled={props.isDeletingItems} onClick={cancelAction}>
        Cancel
      </Button>
    </SidebarFooter>
  );
}

SelectedFeaturesFooter.propTypes = {
  isEditingFeature: PropTypes.bool,
  isDeletingItems: PropTypes.bool,
  selectedFeatures: PropTypes.array,

  // actions
  cancelAction: PropTypes.func,
  showAddToCollectionModal: PropTypes.func,
  showDeleteModal: PropTypes.func,
  showExportModal: PropTypes.func,
  toggleEditStyles: PropTypes.func,
};

export default connect((model) => {
  const {isDeletingItems, isEditingFeature, selectedFeatures } = model.features
  return {
    isDeletingItems,
    isEditingFeature,
    selectedFeatures,
  };
}, actions)(SelectedFeaturesFooter);